/* eslint-disable no-console, class-methods-use-this */
const LOGTYPE_DEBUG = 0;
const LOGTYPE_INFO = 1;
const LOGTYPE_WARN = 2;
const LOGTYPE_ERROR = 3;
let myloggerinstance = null;
let isDebugMode = false;

function sendLog(logType, msg, force) {
  if ((isDebugMode || force) && window && window.console) {
    const newMsg = `Analytics Wrapper -> ${msg}`;
    switch (logType) {
      case LOGTYPE_INFO:
        console.info(newMsg);
        break;
      case LOGTYPE_WARN:
        console.warn(newMsg);
        break;
      case LOGTYPE_ERROR:
        console.error(newMsg);
        break;
      default:
        console.debug(newMsg);
    }
  }
}

export default class Logger {
  constructor(debugMode) {
    isDebugMode = debugMode;
  }

  debug(msg) {
    sendLog(LOGTYPE_DEBUG, msg);
  }

  info(msg) {
    sendLog(LOGTYPE_INFO, msg);
  }

  warn(msg) {
    sendLog(LOGTYPE_WARN, msg);
  }

  error(msg, force) {
    sendLog(LOGTYPE_ERROR, msg, force);
  }

  static getLogger(debugMode) {
    if (debugMode !== null && debugMode !== undefined) {
      isDebugMode = debugMode;
    }
    if (myloggerinstance) return myloggerinstance;
    myloggerinstance = new Logger(debugMode);
    return myloggerinstance;
  }
}
